module.exports = __webpack_public_path__ + "resources/img/img_rancher_m.696973bb1cdda8320e4425286a967fdf.png";